import VawulensImage from "../images/vawulens.png";
import PokemonImage from "../images/pokemonPVP.png";
import MelsKitchenImage from "../images/melskitchen.png";
import TipCalculatorImage from "../images/tipcalculator.png";
import NoteTakingApp from "../images/notetakingapp.png";

export const works = [
  {
    title: "City Of Boston",
    descriptions: [
      "Software Engineering",
      "Digital Equity",
      "Digital Inclusion ",
    ],
    position: "Digital Equity Tech Fellow",
    startYear: "05/2023",
    endYear: "09/2023",
    icons: [
      "Node.js",
      "GitHub",
      "Bash",
      "Vue.js",
      "CSS3",
      "Perl",
      "React",
      "Redux",
    ],
    responsibilities: [
      {
        id: 1,
        description: "Conducted research on digital equity initiatives and programs, identifying key gaps and opportunities in underserved communities.",
        text: "1. Researched",
      },
      {
        id: 2,
        description: "Assisted in the development and implementation of digital literacy workshops, reaching over 100 community members and providing them with essential digital skills.",
        text: "2. Assisted",
      },
      {
        id: 3,
        description: "Collaborated with cross-functional teams to create educational materials and resources to promote digital inclusion and bridge the digital divide.",
        text: "3. Collaborated",
      },
      {
        id: 4,
        description: "Developed a new feature for the Digital Equity platform",
        text: "4. Created",
      },
      {
        id: 5,
        description: "Developed a new feature for the Digital Equity platform",
        text: "5. Innovated",
      },
    ],
  },
  {
    title: "City of Cambridge",
    descriptions: [
      "Software Engineering",
      "Front-end Development",
      "Web Development",
    ],
  
    position: "Frontend Developer",
    icons: [
      "Node.js",
      "Nuxt.js",
      "Bash",
      "Vue.js",
      "CSS3",
      "React",
      "Redux",
    ],
    startYear: "03/2023",
    endYear: "Present",
    responsibilities: [
      {
        id: 1,
        description: "Designed and developed a web application",
      },
      {
        id: 2,
        description: "Created a new feature for the platform",
      },
      {
        id: 3,
        description: "Optimized and enhanced existing platform features",
      },
      {
        id: 4,
        description: "Increased platform performance through strategic enhancements",
      },
      {
        id: 5,
        description: "Independently executed all aspects of project development",
      },
    ],
  },  
  {
    title: "Shields Health",
    position: "Patient Care Representative",
    descriptions: ["A healthcare company"],
    icons: [],
    startYear: "11/2022",
    endYear: "Present",
    responsibilities: [
      {
        id: 1,
        description: `1. Assisted 200+ patients in navigating the healthcare system by answering inquiries over the phone and in person,
          resulting in a 95% patient satisfaction rate as measured by monthly surveys.`,
        text: "1. Assisted",
      },
      {
        id: 2,
        description:
          "2. Efficiently scheduled appointments for 200+ patients per month, reducing average wait times by 10%.",
        text: "2. Scheduled",
      },
      {
        id: 3,
        description:
          "3. Efficiently scheduled appointments for 200+ patients per month, reducing average wait times by 10%.",
        text: "3. Organized",
      },
    ],
  },
  {
    title: "Porter Pediatrics",
    position: "Medical administrative Assistant",
    descriptions: ["A healthcare company"],
    icons: [],
    startYear: "10/2021",
    endYear: "03/2022",
    responsibilities: [
      {
        id: 1,
        description: `1. Provided exceptional customer service as the first point of contact for the practice, managing incoming calls and
        greeting patients at the front desk, resulting in a 25% increase in patient satisfaction as measured by monthly surveys.`,
        text: "1. Provided",
      },
      {
        id: 2,
        description: `2. Efficiently scheduled appointments for 150+ patients per month, streamlining office operations and reducing wait times
          by 15%. -Maintained accurate and up-to-date medical records for 500+ patients, ensuring seamless care coordination
          and reducing record-keeping errors by 30%`,
        text: "2. Scheduled",
      },
    ],
  },
];
export const headerItems = [
  {
    name: "Resume",
    href: "https://drive.google.com/file/d/1fGl55Vp6fV3n4jtjfGak1tA36o1dl0u5/view?usp=drive_link",
  },
  {
    name: "Work",
    href: "#work",
  },
  {
    name: "Projects",
    href: "#projects",
  },
  {
    name: "Contact",
    href: "#contact",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/melanietrodrigues/",
    icon: "linkedin",
  },
  {
    name: "GitHub",
    href: "https://github.com/melanietr98",
    icon: "github2",
  },
  {
    name: "Email",
    href: "mailto:Meltrodriguess@gmail.com",
    icon: "email",
  },
];
export const myProjects = [
  {
    id: 1,
    title: "Mel's Kitchen",
    description:
      "Get delicious Food at your doorsteps. Food website I made using React. Gives you the ability to order food",
    image: MelsKitchenImage,
    liveSite: "https://melskitchenreactapi.netlify.app/",
    github: "https://github.com/melanietr98/restaurant-api",
    technologies: ["react", "nodejs"],
  },
  {
    id: 2,
    title: "Gym Website",
    description:
      "Vawulens is a gym site which offers a range of fitness programs for all levels. Our expert trainers provide personalized training and nutritional guidance. Our state-of-the-art equipment and facilities ensure a challenging and rewarding workout. Join us today and achieve your fitness goals with us!",
    image: VawulensImage,
    liveSite: "https://gymwebsiteapi.netlify.app/",
    github: "https://github.com/melanietr98/gym-website-api",
    technologies: ["react", "nodejs"],
  },
  {
    id: 3,
    title: "Pokemon PVP Game",
    description:
      "This game is a choice-based game inspired by Pokemon Go. In this game, you will be able to choose your Pokemon species, which determines your stats for the game. You will also have the ability to choose your enemy.",
    image: PokemonImage,
    liveSite: "https://melanietr98.github.io/pokemongame/",
    github: "https://github.com/melanietr98/pokemongame",
    technologies: ["vanilljs", "css3"],
  },
  {
    id: 4,
    title: "Note Taking App",
    description: "An app that allows you to take notes",
    image: NoteTakingApp,
    liveSite: "https://notetakingapp.onrender.com/",
    technologies: ["express", "react","css","node.js","mern stack"],
  },
  {
    id: 5,
    title: "Tip Calculator",
    description: "A calculator app that allows you to calculate tips",
    image: TipCalculatorImage,
    liveSite: "https://github.com/melanietr98/tip-calculator",
    technologies: ["nodejs", "expressjs"],
  },
];
